"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import { GridModel } from "@/components/grid/models/grid.model";
export const GridMock = (mock) => {
  mock.onGet("/v1/datas").reply((config) => {
    const _grid = new GridModel();
    for (const _item of [
      {
        "model": "virtualdesktop",
        "id": "virtual_desktop_0a8a159bb75c402c81c84bc8ab9ded7f",
        "name": "80-\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668",
        "open_time": 1620359987e3,
        "type": "remote",
        "config": {
          "model": "virtualdesktop.config",
          "os": "win10x64",
          "language": "en-US",
          "country": "America",
          "timezone": "America/New_York",
          "browser": {
            "model": "virtualdesktop.config.browser",
            "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
            "version": "75.0.3770.100"
          },
          "useragent": "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/75.0.3770.100 Safari/537.36"
        },
        "ip": "47.253.58.117",
        "region": {
          "model": "virtualdesktop.region",
          "id": "region_3e6eea97e4b74de1825fe004951760f6",
          "name": "\u5F17\u5409\u5C3C\u4E9A(\u963F\u91CC)",
          "group": "\u5F17\u5409\u5C3C\u4E9A",
          "category": "\u7F8E\u56FD",
          "has_config": null,
          "config": null
        },
        "validity": {
          "day": 31
        },
        "status": "active",
        "shops": {
          "model": "data.set",
          "datas": [
            // {
            //     "model": "shop",
            //     "id": "shop_638f4a0f5d174716be0f2b08bd085864",
            //     "name": "默认店铺",
            //     "ebusiness": "AMAZON",
            //     "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
            //     "account": null,
            //     "ebusiness_platform_name_cn": "亚马逊美国站",
            //     "marks": {
            //         "model": "tags",
            //         "tags": []
            //     },
            //     "users": {
            //         "model": "data.set",
            //         "datas": [],
            //         "total": 0
            //     }
            // },
            // {
            //     "model": "shop",
            //     "id": "shop_e8e4d7bb22c946eabeeaa32b17adccf9",
            //     "name": "SHOPIFY_EUR",
            //     "ebusiness": "SHOPIFY",
            //     "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/shopify_small.png",
            //     "account": "guorl0227@163.com",
            //     "ebusiness_platform_name_cn": "Shopify欧盟总站",
            //     "marks": {
            //         "model": "tags",
            //         "tags": []
            //     },
            //     "users": {
            //         "model": "data.set",
            //         "datas": [],
            //         "total": 0
            //     }
            // }
          ],
          "total": 0
        },
        "marks": {
          "model": "tags",
          "tags": [
            "IS_ADMIN",
            "REMOTE",
            "OUTLANDS",
            "SUFFICIENT_TRAFFIC"
          ]
        },
        "owners": {
          "model": "data.set",
          "datas": [
            {
              "model": "owner",
              "id": "account_aab33b56853824d06868b73b63a0a1e3a",
              "name": "\u7BA1\u7406\u5458",
              "type": "account"
            }
          ],
          "total": 1
        },
        "expire_in_seconds": 2655767,
        "renew_price": null,
        "expired_time": null
      },
      {
        "model": "virtualdesktop",
        "id": "virtual_desktop_6b8e757aafa745958cb16982527e4ae3",
        "name": "79-\u81EA\u914D\u4EE3\u7406(\u81EA\u5EFA\u4EE3\u7406IP)Win10-64\u4F4D\u8C37\u6B4C\u6D4F\u89C8\u5668",
        "open_time": 1619752624e3,
        "type": "custom",
        "config": {
          "model": "virtualdesktop.config",
          "os": "win10x64",
          "language": "zh-CN",
          "country": "China",
          "timezone": "Asia/Shanghai",
          "browser": {
            "model": "virtualdesktop.config.browser",
            "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
            "version": "78.0.3904.108"
          },
          "useragent": "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/78.0.3904.108 Safari/537.36"
        },
        "ip": "127.0.0.1",
        "region": {
          "model": "virtualdesktop.region",
          "id": "region_0749f8b0d51a407d98499609c395acd4",
          "name": "\u81EA\u914D\u4EE3\u7406(\u81EA\u5EFA\u4EE3\u7406IP)",
          "group": "\u81EA\u914D\u4EE3\u7406",
          "category": "\u672C\u673A&\u81EA\u914D",
          "has_config": null,
          "config": null
        },
        "validity": {
          "day": 31
        },
        "status": "active",
        "shops": {
          "model": "data.set",
          "datas": [
            {
              "model": "shop",
              "id": "shop_7ecfba9573b0445c99615459054e168a",
              "name": "\u9ED8\u8BA4\u5E97\u94FA",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u7F8E\u56FD\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            },
            {
              "model": "shop",
              "id": "shop_4e14602ba9874044ad95f597f889f353",
              "name": "test",
              "ebusiness": "YAHOO",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/yahoo_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "Yahoo(\u65E5\u672C)",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            },
            {
              "model": "shop",
              "id": "shop_cffd4d4855394d87aed13778a137c178",
              "name": "test_new_env",
              "ebusiness": "YAHOO",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/yahoo_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "Yahoo(\u65E5\u672C)",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            }
          ],
          "total": 3
        },
        "marks": {
          "model": "tags",
          "tags": [
            "IS_ADMIN",
            "REMOTE",
            "CAN_BIND_IP",
            "SUFFICIENT_TRAFFIC"
          ]
        },
        "owners": {
          "model": "data.set",
          "datas": [
            {
              "model": "owner",
              "id": "account_aab33b56853824d06868b73b63a0a1e3a",
              "name": "\u7BA1\u7406\u5458",
              "type": "account"
            }
          ],
          "total": 1
        },
        "expire_in_seconds": 2674482,
        "renew_price": null,
        "expired_time": null
      },
      {
        "model": "virtualdesktop",
        "id": "virtual_desktop_2b5f80f08d644fcaa8ae5167cf1eacde",
        "name": "qwe123",
        "open_time": 1617681702e3,
        "type": "remote",
        "config": {
          "model": "virtualdesktop.config",
          "os": "win10x64",
          "language": "zh-CN",
          "country": "China",
          "timezone": "Asia/Shanghai",
          "browser": {
            "model": "virtualdesktop.config.browser",
            "name": "\u8C37\u6B4C\u6D4F\u89C8\u5668",
            "version": "78.0.3904.108"
          },
          "useragent": "Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/78.0.3904.108 Safari/537.36"
        },
        "ip": "39.101.176.71",
        "region": {
          "model": "virtualdesktop.region",
          "id": "region_8f5fcd998b874d47b790dc2d9f39d3b1",
          "name": "\u5F20\u5BB6\u53E3(\u963F\u91CC)",
          "group": "\u5F20\u5BB6\u53E3",
          "category": "\u4E2D\u56FD\u5927\u9646",
          "has_config": null,
          "config": null
        },
        "validity": {
          "day": 30
        },
        "status": "active",
        "shops": {
          "model": "data.set",
          "datas": [
            {
              "model": "shop",
              "id": "shop_05ebfb41792a48a488e74668d23b5dcf",
              "name": "\u8FC1\u79FB\u6765\u7684\u6CD5\u56FD\u7AD9",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u6CD5\u56FD\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_503f5626ed344f6fa94ed169e7c2045b",
              "name": "\u597D\u51E0\u4E2Av",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": "56156114",
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u58A8\u897F\u54E5\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_83c2458ac34c44bca2649a8318ac7cb1",
              "name": "6154564.0",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": "",
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u7F8E\u56FD\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            },
            {
              "model": "shop",
              "id": "shop_faa0b98c20e94371b36cedd764d4e6a6",
              "name": "\u5E97\u94FA\u8FC1\u79FB",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u7F8E\u56FD\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_fc6f63c41d7b4cb68d82f04ff933beea",
              "name": "\u6D4B\u8BD5\u8FC1\u79FB",
              "ebusiness": "AMAZON",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u7F8E\u56FD\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_50371ca13914475bba244d0017b65492",
              "name": "qweqwe",
              "ebusiness": "SHOPIFY",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/shopify_small.png",
              "account": "qw6d51wd5",
              "ebusiness_platform_name_cn": "Shopify",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_ee2db8f1d9a4460592ac7ffe1ea4b9ca",
              "name": "qwe",
              "ebusiness": "EBAY",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/ebay_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "eBay\u9999\u6E2F",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            },
            {
              "model": "shop",
              "id": "shop_f5b0682dde7e41e69d74fb76aaa778a0",
              "name": "\u6B27\u76DF\u603B\u7AD9",
              "ebusiness": "SHOPIFY",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/shopify_small.png",
              "account": "shopifyfuck",
              "ebusiness_platform_name_cn": "Shopify\u6B27\u76DF\u603B\u7AD9",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_a7d938b54c1b428c975c6d826f96e52a",
              "name": "exmail",
              "ebusiness": "QQ",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/qq_small.png",
              "account": "qwe23w5eq45we",
              "ebusiness_platform_name_cn": "\u817E\u8BAF\u4F01\u4E1A\u90AE\u7BB1",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_7ec7bcc616ea4135a4c13196e53c3c63",
              "name": "5651514.0",
              "ebusiness": "FBA",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/fba_small.png",
              "account": "scascas",
              "ebusiness_platform_name_cn": "\u5929\u9A6C\u6D77\u5916\u4ED3",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            },
            {
              "model": "shop",
              "id": "shop_390bbdcc4205461784627f15a3d8ac4b",
              "name": "blibli",
              "ebusiness": "BLIBLI",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/blibli_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "Blibli",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [],
                "total": 0
              }
            },
            {
              "model": "shop",
              "id": "shop_c6d350ea358e4344b05558059d2c7e8a",
              "name": "9687987",
              "ebusiness": "AMAZONVC",
              "logo_url": "https://kuajingvs.oss-cn-qingdao.aliyuncs.com/ebusiness_image/amazon_small.png",
              "account": null,
              "ebusiness_platform_name_cn": "\u4E9A\u9A6C\u900A\u897F\u73ED\u7259\u7AD9VC",
              "marks": {
                "model": "tags",
                "tags": []
              },
              "users": {
                "model": "data.set",
                "datas": [
                  {
                    "model": "shop.user",
                    "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
                    "guid": "user_2a3f5de4dae74e75b9fdc179bae95a22",
                    "account": "136720214790079",
                    "user_no": "79"
                  }
                ],
                "total": 1
              }
            }
          ],
          "total": 12
        },
        "marks": {
          "model": "tags",
          "tags": [
            "IS_ADMIN",
            "REMOTE",
            "CAN_CREATE_ENV_SETTING",
            "SUFFICIENT_TRAFFIC"
          ]
        },
        "owners": {
          "model": "data.set",
          "datas": [
            {
              "model": "owner",
              "id": "account_aab33b56853824d06868b73b63a0a1e3a",
              "name": "\u7BA1\u7406\u5458",
              "type": "account"
            },
            {
              "model": "owner",
              "id": "user_2a3f5de4dae74e75b9fdc179bae95a22",
              "name": "\u54C8\u54C8\u54C8\u54C81231231536156349861498619865156121589641958641",
              "type": "user"
            }
          ],
          "total": 2
        },
        "expire_in_seconds": 2569582,
        "renew_price": null,
        "expired_time": null
      }
    ]) {
      _grid.result.datas.push(__spreadValues({}, _item));
    }
    _grid.page.total = 3;
    _grid.page.current = 1;
    _grid.page.size = 10;
    return [200, _grid];
  });
};
